export default {
    "filterAvatars_loading": "Cargando mas conductores...",
    "filterAvatars_search_drivers": "Buscar conductores"
}